const e = { current: null }, n = { current: !1 };
export {
  n as hasReducedMotionListener,
  e as prefersReducedMotion
};
